(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoCentralController', SSProyectoCentralController);

    SSProyectoCentralController.$inject = ['$state', 'SSProyecto', 'ProgramaEducativo', 'periodos', 'centrosDocentes', 'estatusProyectos', 'ParseLinks', 'AlertService'];

    function SSProyectoCentralController($state, SSProyecto, ProgramaEducativo, periodos, centrosDocentes, estatusProyectos, ParseLinks, AlertService) {

        var vm = this;
        vm.searchForm = {};
        vm.search = search;
        vm.searchType = "filters";

        vm.proyectoAccion = proyectoAccion;
        vm.proyectoDetalleSolicitud = proyectoDetalleSolicitud;
        vm.proyectoSeguimiento = proyectoSeguimiento;
        vm.proyectoDetalleAsignacion = proyectoDetalleAsignacion;
        vm.proyectoEditarVigencia = proyectoEditarVigencia;

        periodos.$promise.then(function (periodos) {
            vm.periodos = periodos;
            vm.selectedPeriodo = periodos[0];
        });

        vm.estatusProyecto = estatusProyectos;
        vm.selectedEstatusProyecto = estatusProyectos[0];

        centrosDocentes.$promise.then(function (centrosDocentes) {
            vm.centrosDocentes = [];
            vm.centrosDocentes.push({ id: 0, nombre: '- Todos' });
            vm.centrosDocentes = vm.centrosDocentes.concat(centrosDocentes);
            vm.selectedCentroDocente = vm.centrosDocentes[0];

            ProgramaEducativo.allByCentroDocente({
                idCentroDocente: vm.selectedCentroDocente.id,
            }).$promise.then(function (programasEducativos) {
                vm.programasEducativos = [];
                vm.programasEducativos.push({ id: 0, nombre: '- Todos' });
                vm.programasEducativos = vm.programasEducativos.concat(programasEducativos);
                vm.selectedProgramaEducativo = vm.programasEducativos[0];
                loadProyectos();
            });
        });

        function search() {
            if (vm.searchType == "filters") {
                if (vm.searchForm.centroDocente.$dirty == true) {
                    ProgramaEducativo.allByCentroDocente({
                        idCentroDocente: vm.selectedCentroDocente.id,
                    }).$promise.then(function (programasEducativos) {
                        vm.programasEducativos = [];
                        vm.programasEducativos.unshift({ id: 0, nombre: '- Todos' });
                        vm.programasEducativos = vm.programasEducativos.concat(angular.copy(programasEducativos));
                        vm.selectedProgramaEducativo = vm.programasEducativos[0];
                        loadProyectos();
                        vm.searchForm.centroDocente.$setPristine();
                    });
                } else {
                    loadProyectos();
                }
            } else if (vm.searchType == "student" && !(vm.alumno == null || vm.alumno == "")) {
                loadAlumno();
            } else {
                vm.sSProyectos = [];
            }
        }

        function loadAlumno() {
            SSProyecto.queryAlumno({
                alumno: vm.alumno
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });
        }

        function loadProyectos() {
            var centroDocente = vm.selectedCentroDocente.id;
            if (vm.selectedProgramaEducativo.id != 0) {
                centroDocente = vm.selectedProgramaEducativo.centroDocente.id;
            }
            SSProyecto.query({
                idCentroDocente: centroDocente,
                idProgramaEducativo: vm.selectedProgramaEducativo.id,
                fechaIniPer: vm.selectedPeriodo.iniPeriodo,
                fechaFinPer: vm.selectedPeriodo.finPeriodo,
                estatusProyecto: vm.selectedEstatusProyecto
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });
        }

        function proyectoDetalleSolicitud(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-central-solicitud', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoSeguimiento(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-central-seguimiento', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoDetalleAsignacion(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-central-detail', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoEditarVigencia(idProyecto, propagation, $event) {
            $state.go('ss-editar-vigencia', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoAccion(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-central-detail', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }
    }
})();
